module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1024-1359e7ae4864b725507d3cd28b37d0fd.png";